function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_150339",
  "data-name": "Path 150339",
  d: "M7.9,17.463h7.784a1.871,1.871,0,0,0,2.108-2.089V7.552a1.869,1.869,0,0,0-2.108-2.089H7.9A1.869,1.869,0,0,0,5.791,7.552v7.822A1.869,1.869,0,0,0,7.9,17.463Zm.765-6a.611.611,0,0,1,.636-.636h1.877V8.94A.608.608,0,0,1,11.8,8.3a.614.614,0,0,1,.636.636v1.883H14.32a.609.609,0,0,1,.63.636.6.6,0,0,1-.63.623H12.437v1.883a.609.609,0,0,1-.636.63.6.6,0,0,1-.624-.63V12.083H9.3A.6.6,0,0,1,8.664,11.46Z",
  transform: "translate(-5.791 -5.463)",
  fill: "#ff0660"
});

function SvgAddIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/add-icon.66c9ba87.svg";
export { ForwardRef as ReactComponent };